'use es6';

import { createSelector } from 'reselect';
import { buildNodePositionsConfig, buildNodePositionsConfigForDataAuthoring, buildNodePositionsConfigForDistractionFreeMode } from 'InpageEditorUI/lib/layoutSection/nodePositionConfig';
import { buildCalculateNodePositionsForConfig } from 'InpageEditorUI/lib/layoutSection/nodePositionCalculator';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getIsDistractionFreeOpen } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
export const getNodePositionConfig = createSelector(
// Even though not currently needed, node position config creation was moved into a selector previously
// so that it could be conditional based on a gate. Figured I'd just leave it like that for now
// instead of unrefactor all of that
[getIsDataAuthoringModeActive, getIsDistractionFreeOpen], (dataAuthoringModeActive, isDistractionFreeOpen) => {
  if (dataAuthoringModeActive) {
    return buildNodePositionsConfigForDataAuthoring();
  }
  if (isDistractionFreeOpen) {
    return buildNodePositionsConfigForDistractionFreeMode();
  }
  return buildNodePositionsConfig();
});
export const getCalculateNodePositionsFunc = createSelector(getNodePositionConfig, nodePositionConfig => {
  return buildCalculateNodePositionsForConfig(nodePositionConfig);
});